import React from "react";
import { ExternalLink, KeyRound, Link2, Loader2 } from "lucide-react";
import { ADMIN_DKIM_URL, DkimField } from "./GwsBits";

/** The one manual step Google leaves us: paste the DKIM TXT from the Admin console. */
export function GwsDkimBox({ site, status, value, onChange, onSave, busyKind }) {
  return (
    <div data-testid="gws-dkim-box" className="border border-amber-500/30 bg-amber-500/5 rounded-sm p-3 space-y-2">
      <div className="flex items-start gap-2 text-xs text-amber-200 leading-relaxed">
        <KeyRound size={13} className="mt-0.5 shrink-0" />
        <div>
          <b>One manual step — DKIM.</b> Google has no API for this. Open{" "}
          <a data-testid="gws-dkim-link" href={status?.dkim_help_url || ADMIN_DKIM_URL} target="_blank" rel="noreferrer" className="underline inline-flex items-center gap-1 hover:text-amber-100">Admin console → Gmail → Authenticate email <ExternalLink size={10} /></a>,
          pick <span className="mono">{site.domain}</span>, click <b>Generate new record</b> (2048-bit, selector <span className="mono">{status?.dkim_selector || "google"}</span>), paste the TXT value below — we write it to Cloudflare. Then click <b>Start authentication</b> there.
        </div>
      </div>
      <DkimField value={value} onChange={onChange} />
      <button data-testid="gws-dkim-save-btn" onClick={onSave} disabled={Boolean(busyKind) || !value.trim()} className="inline-flex items-center gap-1 border border-amber-600 text-amber-200 hover:border-amber-400 px-3 py-1.5 rounded-sm text-xs font-medium disabled:opacity-50">
        {busyKind === "dkim" ? <Loader2 size={12} className="animate-spin" /> : <Link2 size={12} />} Save DKIM &amp; write TXT
      </button>
    </div>
  );
}
